export default __webpack_public_path__ + "static/media/whiteLogo.a22703c2.png";